import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font.ts%22,%22import%22:%22%22,%22arguments%22:[{%22variable%22:%22--main-font%22,%22display%22:%22fallback%22,%22preload%22:true,%22src%22:[{%22path%22:%22../assets/fonts/IRANYekanX/IRANYekanXVF.woff2%22,%22weight%22:%22100%201000%22,%22style%22:%22normal%22}]}],%22variableName%22:%22font%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'font', 'font Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
